import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const countrySelectorStyle: SxProps<Theme> = {
  width: '232px',
  marginRight: YodaSpacing.small,

  '.MuiAutocomplete-root .MuiOutlinedInput-root': {
    borderRadius: '48px',
    border: `2px solid ${YodaColors.gray1}`,

    '& input': {
      '&::placeholder': {
        fontWeight: YodaFontWeight.medium,
        color: YodaColors.textPrimary,
        opacity: 1,
      },
    },
  },

  '.MuiAutocomplete-root .MuiAutocomplete-endAdornment ': {
    marginRight: '6px',
  },

  '.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline ': {
    border: 'none',
  },
};
